export default __webpack_public_path__ + "static/media/ETEF-9.9a4c1097.pdf";